import { render, staticRenderFns } from "./LoyaltyTop.vue?vue&type=template&id=55cbf8a5&scoped=true&"
import script from "./LoyaltyTop.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cbf8a5",
  null
  
)

export default component.exports